// src/features/checklist/utils.js
export const SERVICEPAKKE_KEYS = ["servicepakke", "pakke", "pakker", "servicepakker"];

export function isLineChecklistEligible(line) {
  const arr = Array.isArray(line?.servicetyper) ? line.servicetyper : [];
  return arr.some((t) => SERVICEPAKKE_KEYS.includes(String(t || "").trim().toLowerCase()));
}
